// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.animation, .disappear, .appear {
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
}

.appear {
  height: 100%;
  animation-name: appearAnimation;
}

@keyframes appearAnimation {
  0% {
    height: 0%;
  }
  100% {
    height: 100%;
  }
}
.disappear {
  height: 0;
  animation-name: disappearAnimation;
  border: 0;
  padding: 0;
  margin: 0;
}

@keyframes disappearAnimation {
  0% {
    height: 100%;
  }
  100% {
    height: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/core/notification-banner/notification-banner.component.scss"],"names":[],"mappings":"AACA;EACE,sBAAA;EACA,6BAAA;EACA,sCAAA;AAAF;;AAKA;EAEE,YAAA;EACA,+BAAA;AAHF;;AAMA;EACE;IACE,UAAA;EAHF;EAMA;IACE,YAAA;EAJF;AACF;AAUA;EAEE,SAAA;EACA,kCAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;AATF;;AAYA;EACE;IAEE,YAAA;EAVF;EAYA;IAEE,SAAA;EAXF;AACF","sourcesContent":["// Common properties\r\n.animation {\r\n  animation-duration: 1s;\r\n  animation-fill-mode: forwards;\r\n  animation-timing-function: ease-in-out;\r\n}\r\n\r\n// APPEAR\r\n\r\n.appear {\r\n  @extend .animation;\r\n  height: 100%;\r\n  animation-name: appearAnimation;\r\n}\r\n\r\n@keyframes appearAnimation {\r\n  0% {\r\n    height: 0%;\r\n    // top: -100%;\r\n  }\r\n  100% {\r\n    height: 100%;\r\n    // top: 0;\r\n  }\r\n}\r\n\r\n// DISAPPEAR\r\n\r\n.disappear {\r\n  @extend .animation;\r\n  height: 0;\r\n  animation-name: disappearAnimation;\r\n  border: 0;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n@keyframes disappearAnimation {\r\n  0% {\r\n    // top: 0;\r\n    height: 100%;\r\n  }\r\n  100% {\r\n    // top: -100%;\r\n    height: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
